import store from '../store/store';
import { mutatorAction } from 'satcheljs';
/**
 * Called when we change the value from week start day dropdown, updates the new value in appearance option store
 * @weekStartDay: new value for week start day setting
 */
export default mutatorAction('selectWeekStartDayOption', function selectWeekStartDayOption(weekStartDay) {
    var optionState = store();
    optionState.weekStartDay = weekStartDay;
});
//# sourceMappingURL=selectWeekStartDayOption.js.map